import { makeAutoObservable } from 'mobx';
import { ISaveable } from '../../../../../stores/types';
import { ICredentialsStore } from '../integration-store';
import {IOption} from "../../../../../components/inputs/select-dropdown/select-dropdown";

export interface IBergenCredentials {
    username: string,
    password: string,
    web_address: string,
    warehouse: string,
}

class BergenCredentialsStore implements ISaveable, ICredentialsStore {
    private _changes: IBergenCredentials = {} as IBergenCredentials;
    private readonly warehouseOptions: string[] = [
        'BERGEN LOGISTICS NJ299',
        'BERGEN LOGISTICS NJ3',
        'BERGEN LOGISTICS PA1055',
        'BERGEN LOGISTICS CA2',
        'BERGEN LOGISTICS CAN',
        'BERGEN LOGISTICS NL445',
        'BERGEN LOGISTICS GA7575',
        'ELANDERS UK19',
    ];

    constructor() {
        makeAutoObservable(this);
    }

    public get username() { return this._changes.username; }

    public set username(v: string) { this._changes.username = v; }

    public get password() { return this._changes.password; }

    public set password(v: string) { this._changes.password = v; }

    public get web_address() { return this._changes.web_address; }

    public set web_address(v: string) { this._changes.web_address = v; }

    public get warehouse() { return this._changes.warehouse; }

    public set warehouse(v: string) { this._changes.warehouse = v; }
    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }

    public getWarehouseOptionsList(): IOption[] {
        return this.warehouseOptions.map((warehouse: string) => {
            return {
                label: warehouse,
                value: warehouse,
            }
        }) ?? [];
    }


    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as IBergenCredentials;
    }

    public getUpdatedModel(): IBergenCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }
}

export default BergenCredentialsStore;
